import store from '@/store'
const isElectron = !!process.env.IS_ELECTRON

// 转义字符反转
function unxss(str) {
  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&middot;/g, '·')
}

// 去除字符串中的空格
function trim(str) {
  return str.replace(/\s+/g, '')
}

function getImgUrl(file) {
  if (!store.getters.isElectron) {
    if (file.thumbnail_url) {
      return file.thumbnail_url
    } else {
      return blobToUrl(file.file ? file.file : file)
    }
  } else {
    const fs = require('fs')
    let url = file.thumbnail_url
    if (!file.url) {
      return ''
    }
    let reg = /.*\?/
    let res = url.match(reg)
    if (res) {
      let resUrl = res[0].slice(0, -1)
      const result = window.$global.imageCache.get(resUrl)
      if (result) {
        // 如果有
        try {
          // 判断图片是否还存在本地文件中
          fs.accessSync(result.localPath, fs.constants.F_OK)
          url = 'item:///' + result.localPath
        } catch (err) {
          window.$global.imageCache.delete(resUrl)
          window.$MemoImageStore.removeItem(resUrl)
        }
      }
    }

    //if (file.thumbnail_url) {
    //  return file.thumbnail_url
    //}

    return url
  }
}

function blobToUrl(blob) {
  return window.URL.createObjectURL(blob)
}

function appOpenBlankUrl(url) {
  const { shell } = require('electron')
  shell.openExternal(url)
}

function openUrl(url) {
  if (store.getters.isElectron) {
    appOpenBlankUrl(url)
  } else {
    window.open(url)
  }
}

function throttle(fn, delay) {
  let timer = null
  return function () {
    let context = this
    let args = arguments
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(context, args)
        timer = null
      }, delay)
    }
  }
}

// 获取当前系统类型 mac、win
function getOsType() {
  const agent = navigator.userAgent.toLowerCase()
  if (agent.indexOf('win') > -1) {
    return 'win'
  } else if (agent.indexOf('mac') > -1) {
    return 'mac'
  }
}

// 获取url ? 后面的参数
/**
 * @param {String} url
 * @param {String} name
 * @returns {String}
 */
function getQueryVariable(url, name) {
  var query = url.split('?')[1]
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == name) {
      return pair[1]
    }
  }
  return false
}

function downloadApps() {
  const url =
    getOsType() != 'mac'
      ? 'https://help.flomoapp.com/basic/app.html#windows-%E7%89%88%E6%9C%AC'
      : 'https://help.flomoapp.com/basic/app.html#mac-%E7%89%88%E6%9C%AC'
  if (isElectron) {
    window.ipcRenderer.send('openUrl', url)
  } else {
    window.open(url, '_blank')
  }
}

function isBetaEnv() {
  return location.host === 'stage.flomoapp.com' || location.host === 'localhost:8080'
}

// 判断是不是键盘上特殊符号
function isSpecialChar(str) {
  // 判断键盘按下的是不是特殊符号
  const regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;\\'[\]]/im

  if (regEn.test(str)) {
    return true
  }
  return false
}
// 判断是不是safari
function isSafari() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
    return true
  }
  return false
}

// 判断是不是 ios
function isIos() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('iphone') != -1 || ua.indexOf('ipad') != -1) {
    return true
  }
  return false
}

// is weixin
function isWeixin() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') != -1) {
    return true
  }
  return false
}

// 判断是h5还是 pc
function isPc() {
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent)
  return !isMobile
}

// 解析 url 参数
function parseQueryString(url) {
  var regUrl = /^[^\?]+\?([\w\W]+)$/,
    regPara = /([^&=]+)=([\w\W]*?)(&|$|#)/g,
    arrUrl = regUrl.exec(url),
    ret = {}
  if (arrUrl && arrUrl[1]) {
    var strPara = arrUrl[1],
      result
    while ((result = regPara.exec(strPara)) != null) {
      ret[result[1]] = result[2]
    }
  }
  return ret
}

/**
 * Makes a new build number from current timestamp.
 */
function computeBuildNumber() {
  const now = new Date()
  const year = now.getFullYear().toString()
  const month = (now.getMonth() + 1).toString().padStart(2, '0')
  const day = now.getDate().toString().padStart(2, '0')
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  const seconds = now.getSeconds().toString().padStart(2, '0')

  const formattedTime = year + month + day + hours + minutes + seconds
  return parseInt(formattedTime)
}

// duration 时长区间
function getDurationRange(duration) {
  const range = ['3', '5', '10', '30', '60', '120', '180', '300', '6000'] // 3秒 5秒 10秒 30秒 1分钟 2分钟 3分钟 5分钟 10分钟

  // 把 duration 转换成秒
  const durationSeconds = duration / 1000
  const durationRange = range.find((item) => {
    const itemSeconds = parseInt(item)
    if (durationSeconds < itemSeconds) {
      return true
    }
  })

  // 加上单位
  if (durationRange) {
    if (durationRange >= 60) {
      return durationRange / 60 + 'm'
    }
    return durationRange + 's'
  }

  // 如果 durationRange 不存在，说明超过了 10 分钟
  if (!durationRange) {
    return '10m'
  }

  return durationRange
}

function debounce(callback, delay) {
  let timeoutId

  return function () {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      callback.apply(this, arguments)
    }, delay)
  }
}

function loadLocalScript(scriptName, scriptSource) {
  const script = document.createElement('script')

  // Check if it's a development environment
  if (process.env.NODE_ENV === 'development') {
    script.src = `./${scriptName}`
  } else {
    script.src = scriptSource
  }

  script.name = scriptName

  // Check if the script with the same name already exists
  if (!document.querySelector(`script[name="${scriptName}"]`)) {
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
  }
}

export {
  unxss,
  trim,
  getImgUrl,
  appOpenBlankUrl,
  openUrl,
  throttle,
  getOsType,
  getQueryVariable,
  downloadApps,
  isBetaEnv,
  isSpecialChar,
  isSafari,
  isIos,
  isWeixin,
  isPc,
  parseQueryString,
  computeBuildNumber,
  getDurationRange,
  debounce,
  loadLocalScript,
}
